import React, {useState, useEffect} from 'react';
import {View, Text} from 'react-native';
import Svg, {Circle} from 'react-native-svg';
import {Colors} from '../../../../constants/Colors';

const CircularProgress = ({size = 150, strokeWidth = 10}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => (prev < 100 ? prev + 1 : 100));
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const radius = (size - strokeWidth) / 2;

  const circumference = 2 * Math.PI * radius;

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <View style={{justifyContent: 'center', alignItems: 'center'}}>
      <Svg height={size} width={size}>
        <Circle
          stroke={Colors.GrayPallete.lightgrayTwo}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <Circle
          stroke={Colors.GreenPallete.greenTwo}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
      </Svg>
      <Text
        style={{
          position: 'absolute',
          fontSize: 16,
          lineHeight: 19,
          fontFamily: 'TCCC-UnityHeadline Regular',
        }}>
        {`${Math.round(progress)}%`}
      </Text>
    </View>
  );
};

export default CircularProgress;
